<div class="currency-selector">
  <ng-container *ngIf="singleCurrencyMode; else currencySelector">
    <div class="currency-selector__single-currency" data-qa="currency-selector-single-currency">{{ currency }}</div>
  </ng-container>

  <ng-template #currencySelector>
    <a class="currency-selector__link" tabindex="0" (keydown.enter)="openCurrencyDialog()" (click)="openCurrencyDialog()" data-qa="currency-selector-link">
      {{ currency }}</a
    >
    <lx-side-panel
      i18n-title
      title="Select a currency"
      size="large"
      *ngIf="dialogVisible"
      [visible]="dialogVisible"
      (hiddenPanel)="hideDialog()"
      data-qa="currency-selector-side-panel"
    >
      <lx-currency-list [selectedCurrency]="currency" [currencies]="availableCurrencies" (selectedCurrencyChanged)="selectCurrency($event)"></lx-currency-list>
    </lx-side-panel>
  </ng-template>
</div>
